'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock from "./io.intela.sites.intelacloud.ui.-Markdown$-Block.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading(level, text) {
  this.fi = 0;
  this.fj = null;
  this.fi = level;
  this.fj = text;
}
export { $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading as $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading };
$p = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading.prototype = new $j_io$002eintela$002esites$002eintelacloud$002eui$002e$002dMarkdown$0024$002dBlock.$h_Lio_intela_sites_intelacloud_ui_Markdown$Block();
$p.constructor = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading() {
}
export { $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading as $h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading };
$h_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading.prototype = $p;
$p.q = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, (-1835002398));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, this.fi);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().R(this.fj));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().N(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading) && ((this.fi === x$0.fi) && (this.fj === x$0.fj))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Heading";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.fi;
  }
  if ((n === 1)) {
    return this.fj;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bN)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading as $isArrayOf_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading };
var $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading, "io.intela.sites.intelacloud.ui.Markdown$Block$Heading", ({
  bN: 1,
  aJ: 1,
  b: 1,
  e: 1,
  a: 1,
  Q: 1
}));
export { $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading as $d_Lio_intela_sites_intelacloud_ui_Markdown$Block$Heading };
//# sourceMappingURL=io.intela.sites.intelacloud.ui.-Markdown$-Block$-Heading.js.map
